import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import alertReducer from './alertSlice'
import taskReducer from './taskSlice'
import notificationReducer from './notificationSlice'
import analyticsReducer from './analyticsSlice'
import monitorReducer from './monitorSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    alert: alertReducer,
    task: taskReducer,
    notification: notificationReducer,
    analytics: analyticsReducer,
    monitor: monitorReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export default store 